import { Box, Flex, Stack } from '@chakra-ui/react';
import { Card } from '@main/complykit/components/card';
import { Content } from '@main/complykit/components/slots';
import { Text } from '@main/complykit/components/text';
import { ReactNode } from 'react';

type DomainVerifiedCardProps = {
  domain: ReactNode;
  details: ReactNode;
  actions: ReactNode;
};

export const DomainVerifiedCard = ({ domain, details, actions }: DomainVerifiedCardProps) => (
  <Card>
    <Content>
      <Flex justifyContent="space-between" alignItems="center" gap={3}>
        <Stack spacing={1} minW={0} overflowWrap="anywhere">
          <Text weight="medium">{domain}</Text>
          {details}
        </Stack>
        <Box flexShrink={0}>{actions}</Box>
      </Flex>
    </Content>
  </Card>
);
